import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { INewsletterSaveDto, PLATFORM, Platform, SERVICES_API } from '@pro-connect/shared';

@Injectable({
  providedIn: 'root',
})
export class NewsletterService {
  constructor(
    @Inject(SERVICES_API)
    private readonly _servicesApi: string,
    @Inject(PLATFORM)
    private readonly _platform: Platform,
    private readonly _httpClient: HttpClient,
  ) {}

  /**
   * Submit a message from the newsletter form.
   * @param dto
   * @param recaptchaKey
   */
  public submitMessage(dto: INewsletterSaveDto, recaptchaKey: string): Observable<void> {
    return this._httpClient.post<void>(`${this._servicesApi}/pro/newsletter/${this._platform}/submit`, dto, {
      params: {
        recaptchaKey,
      },
    });
  }
}
